import { render, staticRenderFns } from "./MultiplePageSizesSelection.vue?vue&type=template&id=7a453d19&scoped=true&"
import script from "./MultiplePageSizesSelection.vue?vue&type=script&lang=js&"
export * from "./MultiplePageSizesSelection.vue?vue&type=script&lang=js&"
import style0 from "./MultiplePageSizesSelection.vue?vue&type=style&index=0&id=7a453d19&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a453d19",
  null
  
)

export default component.exports